import React, { useState } from 'react';

import InputAmountForLanding from 'apps/promo/components/form/InputAmountForLanding';

import AmountCurrency from './AmountCurrency';
import { AmountRow } from './styles';
import PromoCountryList from '../CalculatorDropdownNew/PromoCountryList';

export const Amount = (props) => {
    const [isCountryListOpen, setIsCountryListOpen] = useState(false);

    const toggleCountryList = () => {
        setIsCountryListOpen(!isCountryListOpen);
    };

    return (
        <AmountRow>
            {isCountryListOpen ? (
                <PromoCountryList
                    role={props.role}
                    toggleCountryList={toggleCountryList}
                    country={props.country}
                    onDropdownChange={props.onDropdownChange}
                    showCurrencies
                />
            ) : (
                <InputAmountForLanding
                    isNewInput
                    value={props.amount}
                    handleValueChange={props.setAmount}
                    labelText={props.labelText}
                    errorMessage={props.errorMessage}
                >
                    <AmountCurrency countryCode={props.country} currencyCode={props.currency} toggleCountryList={toggleCountryList} />
                </InputAmountForLanding>
            )}
        </AmountRow>
    );
};
